import { OnInit, Component, HostBinding } from '@angular/core';
import { CompletedUnpaidDashboardStore } from '../../service/completed-unpaid-dashboard.store';
import { Observable } from 'rxjs/Observable';
import { DashboardUtils } from '../../utils/dashboard-util';
import { PredefinedSearchService } from '../../service/predefined-search.service';

@Component({
  selector: 'pioneer-completed-unpaid',
  templateUrl: './completed-unpaid.component.html'
})
export class CompletedUnpaidComponent implements OnInit {
  private readonly defaultClasses = 'card collapse';

  @HostBinding('id') id = 'card-1';
  @HostBinding('attr.data-se-id') dataSeId = 'completedAndUnpaidCard';
  @HostBinding('class') classes = this.defaultClasses;

  constructor(
    private completedUnpaidStore: CompletedUnpaidDashboardStore,
    private predefinedSearchService: PredefinedSearchService
  ) {}

  ngOnInit(): void {

    const cardStateObs = this.completedUnpaidStore.cardStateCssClass().map((newClass: string) => {
      return this.defaultClasses + ' ' + newClass;
    });

    const combined = Observable.combineLatest(
      cardStateObs,
      this.completedUnpaidStore.showCard()
    );

    combined.subscribe( (fromCombined: [string, boolean]) => {
      const [classes, show] = fromCombined;
      if (show) {
        this.classes = `${classes} show`;
      } else {
        this.classes = classes;
      }
    });

  }

  get completedAndUnpaidLessThan15DaysTotal(): Observable<string> {
    return DashboardUtils.totalAsStringClampedTo99(this.completedUnpaidStore.lessThan15DaysTotal);
  }

  get completedAndUnpaidBetween15And28DaysTotal(): Observable<string> {
    return DashboardUtils.totalAsStringClampedTo99(this.completedUnpaidStore.between15And28DaysTotal);
  }

  get completedAndUnpaidGreaterThan28DaysTotal(): Observable<string> {
    return DashboardUtils.totalAsStringClampedTo99(this.completedUnpaidStore.greaterThan28DaysTotal);
  }

  completedAndUnpaidPredefinedSearch(): void {
    this.predefinedSearchService.completedAndUnpaid();
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/dashboard/completed-unpaid/completed-unpaid.component.ts